import { render } from "./WhatsappSvg.vue?vue&type=template&id=fb3c34f8"
import script from "./WhatsappSvg.vue?vue&type=script&lang=js"
export * from "./WhatsappSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__